export default __webpack_public_path__ + "b27c9dd8471cb990586036c7c4dad31a.png";